export default __webpack_public_path__ + "static/media/wiko-alpha.093ff622.png";